<template>
  <div class="container-withdraw-account" :class="[packageName]">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px; background-color: #f7f6f9;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.wd.withdrawAccount') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <!-- 图标 -->
      <div class="account-tit">
        <div class="account-img">
          <img :src="icon | imgPath" alt="" />
        </div>
        <span class="line"></span>
        <div class="account-name">{{ withdrawalMethod }}</div>
      </div>

      <!-- 提现名 -->
      <div class="select">
        <span>{{ $t('lang.wd.cc') }}</span>
        <div class="country">
          <img :src="locaFlag | imgPath" alt="" />
          <div class="account-name">{{ locaCode }}</div>
        </div>
      </div>

      <!-- 哥伦比亚 且是 Transfer bancaria -->
      <template v-if="locaCode === 'CO'">
        <!-- 姓名 -->
        <div class="select">
          <span>Nombre del Cliente</span>
          <input style="color: #333" type="text" placeholder="Por favor, rellene" v-model.trim="columbiaForm.accountName" />
        </div>
        <!-- 地址 -->
        <div class="select">
          <span>Dirección del Cliente</span>
          <input style="color: #333" type="text" placeholder="Por favor, rellene" v-model.trim="columbiaForm.accountAddress" />
        </div>
        <!-- 选择（身份类型） -->
        <div class="select">
          <span>Identificación del Cliente</span>
          <van-field v-model="pickerTypeValue1" is-link readonly label="" placeholder="Por favor seleccione" @click="showTypePicker1 = true" />
        </div>
        <!-- 身份类型-填写 -->
        <template v-if="pickerTypeValue1 !== ''">
          <div class="select">
            <input
              style="color: #333"
              type="text"
              :maxlength="pickerTypeValue1 === 'Cédula de Identidad' ? 10 : 8"
              :placeholder="pickerTypeValue1 === 'Cédula de Identidad' ? 'Por favor, introduzca 10 caracteres' : 'Ingrese un máximo de 8 dígitos'"
              v-model.trim="columbiaForm.idNumber"
            />
          </div>
        </template>
        <!-- 邮件 -->
        <div class="select">
          <span>Correo Electrónico del Cliente</span>
          <input style="color: #333" type="text" placeholder="Por favor, rellene" v-model.trim="columbiaForm.email" />
        </div>
        <!-- 姓氏 -->
        <div class="select">
          <span>Apellido</span>
          <input style="color: #333" type="text" placeholder="Por favor, rellene" v-model.trim="columbiaForm.lastName" />
        </div>
        <!-- 电话 -->
        <div class="select">
          <span>Teléfono del Cliente</span>
          <input
            style="color: #333"
            type="number"
            placeholder="Ingrese un máximo de 10 dígitos"
            maxlength="10"
            @input="
              (ev) => {
                columbiaForm.phoneNumber = ev.target.value.slice(0, 10)
              }
            "
            v-model.trim="columbiaForm.phoneNumber"
          />
        </div>
        <!-- 选择（账户类型） -->
        <div class="select">
          <span>Tipo de Cuenta</span>
          <van-field v-model="pickerTypeValue2" is-link readonly label="" placeholder="Por favor seleccione" @click="showTypePicker2 = true" />
        </div>
        <!-- 账户 -->
        <div class="select">
          <span>Cuenta</span>
          <input style="color: #333" type="number" placeholder="Por favor, rellene" v-model.trim="columbiaForm.accountId" />
        </div>
        <!-- 选择（银行） -->
        <div class="select">
          <span>ID del Banco y Nombre del Banco</span>
          <van-field v-model="bankText" is-link readonly label="" :placeholder="$t('lang.wd.bankName')" @click="showBankPicker = true" />
        </div>
      </template>

      <template v-else>
        <div class="select">
          <span>{{ $t('lang.wd.name') }}</span>
          <input style="color: #333" type="text" :placeholder="$t('lang.wd.phYourName')" v-model.trim="accountName" />
        </div>

        <div class="select">
          <span>{{ $t('lang.wd.phAccount') }}</span>
          <div class="select-account">
            <input type="text" :placeholder="$t('lang.wd.phAccount')" v-model="accountId" />
          </div>
        </div>
      </template>

      <!-- 保存按钮 -->
      <div class="save-btn" :class="{ 'save-btn-act': this.saveFlag() }" @click="handleSave">
        {{ cfgId ? $t('lang.change') : $t('lang.wd.save') }}
      </div>
    </div>

    <!-- 选择银行弹窗 -->
    <van-popup v-model="showBankPicker" destroy-on-close round position="bottom">
      <van-picker
        show-toolbar
        :key="locaCode"
        :cancel-button-text="$t('lang.cfm.cancelBtn')"
        :confirm-button-text="$t('lang.confirm')"
        :model-value="pickerValue"
        :columns="bankList"
        @cancel="showBankPicker = false"
        @confirm="handleBankPickerConfirm"
      />
    </van-popup>

    <!-- 哥伦比亚-选择类型弹窗-1 -->
    <van-popup v-model="showTypePicker1" destroy-on-close round position="bottom">
      <van-picker
        show-toolbar
        :key="locaCode"
        :cancel-button-text="$t('lang.cfm.cancelBtn')"
        :confirm-button-text="$t('lang.confirm')"
        :model-value="pickerTypeValue1"
        :columns="columbiaList1"
        @cancel="showTypePicker1 = false"
        @confirm="handleTypePickerConfirm1"
      />
    </van-popup>

    <!-- 哥伦比亚-选择类型弹窗-2 -->
    <van-popup v-model="showTypePicker2" destroy-on-close round position="bottom">
      <van-picker
        show-toolbar
        :key="locaCode"
        :cancel-button-text="$t('lang.cfm.cancelBtn')"
        :confirm-button-text="$t('lang.confirm')"
        :model-value="pickerTypeValue2"
        :columns="columbiaList2"
        @cancel="showTypePicker2 = false"
        @confirm="handleTypePickerConfirm2"
      />
    </van-popup>
  </div>
</template>

<script>
import { apiBindWithdrawAccount, apiEditWithdrawAccount } from '@/api/imee.js'

import _debounce from 'lodash/debounce'
import baseMixin from '../base.mixin.js'

export default {
  mixins: [baseMixin],
  data() {
    return {}
  },
  methods: {
    // 保存
    handleSave: _debounce(
      function () {
        // 去掉空格
        const strAccountId = `${this.accountId}`
        this.accountId = strAccountId.replace(/\s*/g, '')

        // 判断emoji表情
        if (this.hasEmojiCharacter(this.accountName)) {
          this.accountName = ''
          this.$client.showToast(this.$t('lang.wd.emojiTip'))
          return
        }

        let data = {
          accountId: this.accountId,
          accountName: this.accountName
        }

        // 哥伦比亚的 Transfer bancaria
        if (this.withdrawalMethod === 'Transfer bancaria') {
          if (this.locaCode === 'CO') {
            data = {
              accountAddress: this.columbiaForm.accountAddress,
              accountId: this.columbiaForm.accountId,
              accountName: this.columbiaForm.accountName,
              accountType: this.columbiaForm.accountType,
              bankCode: this.columbiaForm.bankCode,
              email: this.columbiaForm.email,
              idNumber: this.columbiaForm.idNumber,
              idType: this.columbiaForm.idType,
              lastName: this.columbiaForm.lastName,
              phoneNumber: this.columbiaForm.phoneNumber,
              withdrawalMethod: this.withdrawalMethod
            }
            const targetLength = `${this.columbiaForm.idNumber}`.length
            if (this.pickerTypeValue1 === 'Cédula de Identidad' && (targetLength < 6 || targetLength > 10)) {
              this.$client.showToast('Cédula de Identidad Por favor ingrese 10 dígitos')
              return
            }
            if (this.pickerTypeValue1 === 'Cédula de Identidad de Extranjero' && (targetLength === 0 || targetLength > 8)) {
              this.$client.showToast('Ingrese un máximo de 8 dígitos')
              return
            }
            if (`${this.columbiaForm.phoneNumber}`.length < 10) {
              this.$client.showToast('Teléfono del Cliente Por favor ingrese 10 dígitos')
              return
            }
          }
        }

        // edit
        if (this.cfgId) {
          apiEditWithdrawAccount(data, this.cfgId).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
        // add
        else {
          data.withdrawalMethod = this.withdrawalMethod
          apiBindWithdrawAccount(data).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
      },
      3000,
      {
        leading: true,
        trailing: false
      }
    ),
    // 保存校验
    saveFlag() {
      if (this.withdrawalMethod === 'Transfer bancaria') {
        if (this.locaCode === 'CO') {
          if (
            this.columbiaForm.accountAddress &&
            this.columbiaForm.accountId &&
            this.columbiaForm.accountName &&
            this.columbiaForm.accountType &&
            this.columbiaForm.bankCode &&
            this.columbiaForm.email &&
            this.columbiaForm.idNumber &&
            this.columbiaForm.idType &&
            this.columbiaForm.lastName &&
            this.columbiaForm.phoneNumber
          ) {
            return true
          }
        }
        return false
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../base.scss';
</style>
